import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function StickyAnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-pink-600 text-white py-1.5 px-4 shadow-md" data-id="element-193">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center" data-id="element-194">
        <span className="font-bold text-xs md:text-sm" data-id="element-195">
          🔥 50% OFF + 10 BONOS GRATIS
        </span>
        <span className="text-brand-pink-300 hidden sm:block" data-id="element-196">·</span>
        <div className="hidden sm:flex items-center gap-1 text-xs" data-id="element-197">
          <span className="text-brand-pink-200" data-id="element-198">Termina en:</span>
          <CountdownTimer compact data-id="element-199" />
        </div>
      </div>
    </div>;
}